module.exports = __webpack_public_path__ + "media/images/checked-088bfa6a8dbc64ee9dc0fc80748e3781.svg";